import FouPicture from 'components/tools/fou-picture/'
import DownloadIcon from 'components/icons/download/'
import Methods from './methods'
import Computed from './computed'
import SubmissionComputed from 'src/pages/submissions/script/common.computed'
import SubmissionMethods from 'src/pages/submissions/script/common.methods'
import FouGrid from 'components/layout/fou-grid/'
import FouGroup from 'components/layout/fou-group/'
import { mapGetters, mapActions } from 'vuex'
import AnimationProcessing from 'components/animations/processing'
import Misc from 'src/utils/helper/misc'
import { Carousel, Slide, Navigation } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'

export default {
  name: 'preview',

  components: {
    FouPicture,
    ...FouGrid,
    FouGroup,
    DownloadIcon,
    AnimationProcessing,
    Carousel,
    Slide,
    Navigation
  },

  data() {
    return {
      fontURI: process.env.MY_FONTS_URL,
      slideTo: 0,
      showPills: true
    }
  },
  computed: {
    ...Computed,
    ...SubmissionComputed,
    ...mapGetters('binaries', ['getBinaryFontRenderSrc']),
    ...mapGetters('auth', ['hasRole', 'user'])
  },
  methods: {
    ...Methods,
    ...SubmissionMethods,
    ...Misc,
    ...mapActions('downloadBinaryImages', ['downloadBinaries', 'downloadImages']),
    downloadGraphics(sId) {
      this.downloadImages(sId)
        .then(url => {
          window.location.href = url
        })
        .catch(() => {})
    },
    downloadFonts(sId) {
      this.downloadBinaries(sId)
        .then(url => {
          window.location.href = url
        })
        .catch(() => {})
    },
    slideToImage(id) {
      this.slideTo = id
    },
    manageThumbnailIndex({ slidingToIndex, slidesCount }) {
      if (slidingToIndex >= slidesCount) {
        this.slideTo = 0
      } else if (slidingToIndex < 0) {
        this.slideTo = slidesCount - 1
      } else {
        this.slideTo = slidingToIndex
      }
      this.$nextTick()
    },
    getSinglePack(obj) {
      if (obj.name === '' || !obj.hasOwnProperty('name')) {
        const packName = []
        packName.push(this.submissionFamilyName, obj.styles[0].binaryName)
        return packName.join(' ')
      }
      return obj.name
    }
  }
}
